import { SampleReporter } from "./SampleReporter";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useCallback, useState, useMemo } from "react"
import Table from 'react-bootstrap/Table';
import { formatDate } from "../CustomDateTools";
import {
  ColumnDef,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  createColumnHelper,
  SortingFn,
  SortingState,
  useReactTable,
} from '@tanstack/react-table'

const columnHelper = createColumnHelper();


const getAnumberCol = (sample) => {
  return (<>
    {sample.properties.anumber}
    {(sample.properties.reported_sample_anumber_id !== null ?
      <FontAwesomeIcon title="The samples related to this A Number have been reported as inaccurate or incorrect." style={{ marginLeft: 3 }} icon={faCircleExclamation} />
      : "")}
  </>)
}

const getSampleIdCol = (sample) => {
  return (<>
    {sample.properties.id}
    {(sample.properties.reported_sample_id !== null ?
      <FontAwesomeIcon title="This Sample Has been reported as inaccurate or incorrect." style={{ marginLeft: 3 }} icon={faCircleExclamation} />
      : "")}</>)
}

const columns = [
  columnHelper.accessor(row => row.properties.id, {
    id: "id",
    cell: info => getSampleIdCol(info.row.original),
    header: () => <>Sample ID</>,
  }),
  columnHelper.accessor(row => row.properties.companysampleid, {
    id: "company-id",
    cell: info => <>{info.getValue()}</>,
    header: () => <>Company Sample ID</>,
  }),
  columnHelper.accessor(row => row.properties.anumber, {
    id: "anumber",
    cell: info => getAnumberCol(info.row.original),
    header: () => <>A Number</>,
  }),
  columnHelper.accessor(row => row.properties.au_ppb, {
    id: "au_ppb",
    cell: info => <>{info.getValue()}</>,
    header: () => <>PPB Value</>,
  }),
  columnHelper.accessor(row => row.properties.surfacesampletype, {
    id: "surfacesampletype",
    cell: info => <>{info.getValue()}</>,
    header: () => <>Sample Type</>,
  }),
  columnHelper.accessor('mineral', {
    cell: info => <>Au</>,
    header: () => <>Mineral</>,
  })
]

export function MarkerTable({ markers, setSelectedMarker, selectedMarker }) {


  const [modalShow, setModalShow] = useState(false);
  const [reportedAssay, setReportedAssay] = useState({ properties: {} });

  const [sorting, setSorting] = useState([])


  const table = useReactTable({
    columns,
    data: markers.features,
    debugTable: false,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(), //client-side sorting
    onSortingChange: setSorting, //optionally control sorting state in your own scope for easy access
    // sortingFns: {
    //   sortStatusFn, //or provide our custom sorting function globally for all columns to be able to use
    // },
    //no need to pass pageCount or rowCount with client-side pagination as it is calculated automatically
    state: {
      sorting,
    },
    // autoResetPageIndex: false, // turn off page index reset when sorting or filtering - default on/true
    // enableMultiSort: false, //Don't allow shift key to sort multiple columns - default on/true
    // enableSorting: false, // - default on/true
    // enableSortingRemoval: false, //Don't allow - default on/true
    // isMultiSortEvent: (e) => true, //Make all clicks multi-sort - default requires `shift` key
    // maxMultiSortColCount: 3, // only allow 3 columns to be sorted at once - default is Infinity
  })

  return (
    <>
      <SampleReporter reportedAssay={reportedAssay} show={modalShow} onHide={() => setModalShow(false)} />
      <Table striped bordered hover>
        <thead style={{
          position: "sticky",
          top: "0"
        }}>
          {table.getHeaderGroups().map(headerGroup => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map(header => {
                return (
                  <th
                    key={header.id}
                    colSpan={header.colSpan}>

                    {header.isPlaceholder ? null : (
                      <div
                        className={
                          header.column.getCanSort()
                            ? 'cursor-pointer select-none'
                            : ''
                        }
                        onClick={header.column.getToggleSortingHandler()}
                        title={
                          header.column.getCanSort()
                            ? header.column.getNextSortingOrder() === 'asc'
                              ? 'Sort ascending'
                              : header.column.getNextSortingOrder() === 'desc'
                                ? 'Sort descending'
                                : 'Clear sort'
                            : undefined
                        }
                      >
                        {flexRender(
                          header.column.columnDef.header,
                          header.getContext()
                        )}
                        {{
                          asc: ' 🔼',
                          desc: ' 🔽',
                        }[header.column.getIsSorted()] ?? null}
                      </div>
                    )}
                  </th>
                )
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          {table
            .getRowModel()
            .rows
            .map(row => {
              return (
                <tr key={row.id} className={(selectedMarker.properties !== undefined
                  ? (selectedMarker.properties.id === row.original.properties.id ? "table-warning" : "")
                  : ("")
                )} onClick={() => setSelectedMarker(row.original)}>
                  {row.getVisibleCells().map(cell => {
                    return (
                      <td key={cell.id}>
                        {flexRender(
                          cell.column.columnDef.cell,
                          cell.getContext()
                        )}
                      </td>
                    )
                  })}
                  <td style={{ width: "13%" }}>
                    {
                      (
                        row.original.properties.reported_sample_anumber_id === null && row.original.properties.reported_sample_id === null ?
                          <button className="btn btn-secondary btn-sm" onClick={() => {
                            setModalShow(true);
                            setReportedAssay(row.original.properties)
                          }}>Report Sample</button>
                          : ""
                      )
                    }
                  </td>
                </tr>
              )
            })}
        </tbody>
      </Table>
    </>
  )
}